import { render, staticRenderFns } from "./SchemaLayout.vue?vue&type=template&id=4474c12c"
import script from "./SchemaLayout.vue?vue&type=script&lang=js"
export * from "./SchemaLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports